<template>
  <div class="w-full max-w-[80vw]">
    <div class="flex flex-col min-w-[16rem] w-full">
      <div class="p-4 flex flex-col gap-3">
        <div class="flex flex-col gap-1.5">
          <s-label :for="fromId">{{ t(labelStyle + '.from') }}</s-label>
          <s-input :id="fromId" type="date" v-model="startDate" />
        </div>
        <div class="flex flex-col gap-1.5">
          <s-label :for="toId">{{ t(labelStyle + '.to') }}</s-label>
          <s-input :id="toId" type="date" v-model="endDate" />
        </div>
      </div>
      <s-btn class="!rounded-t-none !rounded-b-lg" @click.stop="applyDateRange" icon="filter">
        {{ $t('filter.apply') }}
      </s-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, useId, watch} from 'vue';
import SInput from './SInput.vue';
import SBtn from './SBtn.vue';
import SLabel from './SLabel.vue';
import {useI18n} from 'vue-i18n';

const fromId = useId();
const toId = useId();

type LabelStyle = 'after-before' | 'from-to';

const props = defineProps<{
  labelStyle?: LabelStyle;
  modelValue: {start?: string | null; end?: string | null} | null;
}>();

const emit = defineEmits(['update:modelValue', 'close']);

const {t} = useI18n({
  inheritLocale: true,
  useScope: 'local',
});

const startDate = ref(props.modelValue?.start || '');
const endDate = ref(props.modelValue?.end || '');

// Watch for changes in modelValue
watch(
  () => props.modelValue,
  (newValue) => {
    startDate.value = newValue?.start || '';
    endDate.value = newValue?.end || '';
  },
  {immediate: true}
);

function applyDateRange(): void {
  if (startDate.value || endDate.value) {
    emit('update:modelValue', {start: startDate.value, end: endDate.value});
    emit('close');
  }
}
</script>
<i18n>
{
  "en": {
    "after-before": {
      "from": "After",
      "to": "Before"
    },
    "from-until": {
      "from": "From",
      "to": "Until"
    }
  },
  "fr": {
    "after-before": {
      "from": "Après",
      "to": "Avant"
    },
    "from-until": {
      "from": "De",
      "to": "Jusqu'à"
    }
  }
}
</i18n>
